
import Vue from "vue"
import Multiposting from "@/components/Multiposting.vue"

export default Vue.extend({
    components: {
        Multiposting,
    },
    created() {
        document.title = this.$vuetify.lang.t("$vuetify.tab_titles.multiposting")
    }
})
